// extracted by mini-css-extract-plugin
export default {"container":"yP6x"};